import React, { useContext, useEffect, useState } from 'react';
import {
  Placeholder,
  ComponentRendering,
  ComponentParams,
  ComponentFactory,
  Field,
  SitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { isLoggedIn } from '../../utils/authHelper';
import { APIWebstoreContext } from '../../context/globalContext';
import BackToTopButton from '../BackToTopButton/BackToTopButton';
import { ICP_IDENTIFIER } from '../../utils/constants';

// Interfaces
export interface UnifiedPaymentPageProps {
  fields: {
    Heading: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
}

interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

export interface InvoiceDetailsSection {
  GroupNumber: string;
  GroupInvoiceId: string;
  UnpaidInvoices: UnpaidInvoice[];
}

export interface UnpaidInvoice {
  GroupNumberInvoiceId: string;
  UnpaidInvoice: string;
  Name: string;
  OrderNumber: string;
  Program: string;
  TotalAmount: number;
}

const UnifiedPaymentPage = (props: Props): React.JSX.Element => {
  const { state, dispatch } = useContext(APIWebstoreContext);
  const [invoiceQuantity, setInvoiceQuantity] = useState(0);
  const [invoiceIdentifier, setInvoiceIdentifier] = useState('');

  useEffect(() => {
    try {
      const rawQuery = window.location.search;
      const queryParams = new URLSearchParams(rawQuery);
      const unpaidInvoices = (queryParams.get('UnpaidInvoices') || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);

      const groupIdentifier = queryParams.get('GroupNumberInvoiceId');
      setInvoiceIdentifier(groupIdentifier ? ICP_IDENTIFIER : 'CustomInvoice');

      setInvoiceQuantity(unpaidInvoices.length);
    } catch (error) {
      console.error('Error parsing invoice parameters:', error);
    }
  }, [dispatch]);

  return isLoggedIn() && invoiceQuantity > 0 ? (
    <div className="unified-payment-page-main">
      <Placeholder
        name="page_unifiedpaymentdetails"
        rendering={props.rendering}
        invoiceIdentifier={invoiceIdentifier}
      />
      {!state?.hasInvalidInvoices && (
        <Placeholder
          name="page_invoicesummary"
          rendering={props.rendering}
          invoiceIdentifier={invoiceIdentifier}
        />
      )}
      <BackToTopButton />
    </div>
  ) : (
    <>
      <div className="unified-payment-empty-cart">
        <h1 className="paymentPageTitle red-title">Unified Invoices is empty</h1>
        <h3>
          {(state?.sitecoreDictionaryData &&
            state?.sitecoreDictionaryData?.UnpaidInvoicesEmptyMessage) ||
            'Unified Payment Invoices is empty'}
        </h3>
        <Placeholder name="continue_shopping" rendering={props.rendering} />
      </div>
    </>
  );
};

export default UnifiedPaymentPage;
